import React from "react";
import { Image, Link, Flex } from "@chakra-ui/react";

import { useContextConsumer } from "modules/context/Providers/ContextProvider";

import { ContentArea } from "components/ContentArea";
import { ChakraText } from "components/ChakraText";
import { DangerousInnerHtml } from "components/DangerousInnerHtml";

import { ButtonUp } from "./ButtonUp";

import wcagLogoUrl from "../../../assets/wcag_logo.png";

const Footer = () => {
  const {
    corporateMarkEnabled,
    footerHtml,
    w3cInfoShow,
  } = useContextConsumer();
  return (
    <ContentArea
      minH="120px"
      p={6}
      alignItems={{ md: "stretch", base: "center" }}
      justifyContent="spaceAround"
      d="flex"
      flexDirection={{
        base: "column",
        md: "row",
      }}
    >
      <Flex direction="column" flex={{ base: "0 0 100px", md: "0 0 200px" }}>
        {w3cInfoShow && (
          <Image h="31px" w="88px" alt="W3C logo" src={wcagLogoUrl} />
        )}
        {corporateMarkEnabled && (
          <ChakraText>
            System jest częścią{" "}
            <Link href="http://www.madkom.pl/biuletyn-informacji-publicznej">
              SIDAS BIP
            </Link>
          </ChakraText>
        )}
      </Flex>
      <Flex
        w="100%"
        justifyContent="center"
        sx={{ img: { display: "inline" } }}
      >
        <DangerousInnerHtml width="100%" html={footerHtml} />
      </Flex>
      <Flex flex="0 0 200px" alignItems="center" justifyContent="flex-end">
        <ButtonUp />
      </Flex>
    </ContentArea>
  );
};

export { Footer };
